<template>
<div>
    <q-input 
        :style="{width: width+'px'}"
        v-bind="$attrs"
        v-on="inputListeners"
        :disable="disable"
        :after="after"
        />
        </div>
</template>

<script>
import moment from 'moment'
export default {
    name: 'SLDatePicker',
    props: {
        disable: {
            default: false
        },
        label : {
            default: 'Date'
        },
        type: {
            default: 'datetime' // datetime, date, time
        },
        model: {
            default: () => null
        },
        after: {
            default: null
        },
        input: {
            default: () => null
        },
        format: {
            default: function () { return this.$store.state.shared.formats[this.type] }
        },
        width: {
            default: () => 150
        },
        blur: {
            default: () => null
        },
        errorLabel: {
            default: 'MM/DD/YYYY'
        },
        error: {
            default: false
        }
    },
    data () {
        return {
            modelClone: this.model
        }
    },
    
    computed: {
        // Cannot try it this way.. We are forcing the date to be rendered when they are typing.
        // formatDateToLocal () {
        //     return moment(this.$attrs.value).isValid() ? moment(this.$attrs.value).format('L') : null
        // },
        inputListeners () {
            var vm = this
            // `Object.assign` merges objects together to form a new object
            return Object.assign( {},
                // We add all the listeners from the parent
                this.$listeners,
                // Then we can add custom listeners or override the
                // behavior of some listeners.
                {
                // This ensures that the component works with v-model
            })
        }
    },
    methods: {
        // showError () {
        //     this.input(this.modelClone)
        // }

    }
}
</script>

<style>
</style>
